import React from 'react';
import { FDBox, FDContentContainer, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('InvestmentApproachLayout', () => ({
  flexibleChild: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '& > *': {
      display: 'flex !important', // Needed to override FDContentContainer's display:block
      flexDirection: 'column',
      flex: 1,
      justifyContent: 'center',
    },
  },
}));

const Layout = () => {
  const classes = useStyles();

  return (
    <div className={classes.flexibleChild}>
      <FDContentContainer maxWidth={'md'}>
        <FDStack direction={'column'} spacing={4} alignItems={'center'}>
          <MetaControlField attr="title" />
          <FDBox maxWidth={'65%'}>
            <MetaControlField attr="subtitle" />
          </FDBox>
          <MetaControlField attr="sections" />
        </FDStack>
      </FDContentContainer>
    </div>
  );
};

export default Layout;
